import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import EmptyPage from '../../components/empty-page/emptyPage';
import './supAbandonBookings.css';
import { standardDate } from '../../utils/formatDate';
import { getOrganizers } from '../../utils/getOrganizers';
import { getSupAbandonList } from '../../api/supportAPI';

const SupAbandonBookings = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [orgData, setOrgData] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState('');
    const [selectedType, setSelectedType] = useState('upcoming');
    const [datesType, setDatesType] = useState('fixed');
    const [group, setGroup] = useState('backpacking');
    const [limit] = useState(10);
    const [offSet, setOffSet] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const tableHeader = [
        'Trip Name',
        'name',
        'Start City',
        'Pick Up',
        'Booked On',
        'Payment',
        'Seats',
        'Transport',
        'Booked Via',
        'People',
        'Ticket Status'
    ];

    const customTabelHeadre = [
        'Trip Name',
        'Name',
        'Start City',
        'Pick Up',
        'Booked On',
        'Seats',
        'Rooms',
        'Bed',
        'Payment',
        'IsGroup',
        'Vehicle',
        'Booked Via',
        'People'
    ];

    const getUserDetails = (row) => {
        return row.userDetails.map(function (user, userKey) {
            return (
                <div key={userKey}>
                    <span>{user?.name ?? 'N/A'}, </span>
                    <span>{user?.age ?? 'N/A'}, </span>
                    <span>{user?.sex ?? 'N/A'}, </span>
                    <span>{user?.phoneNumber ?? 'N/A'}</span>
                </div>
            );
        });
    };

    const fetchAbandonBookings = async () => {
        try {
            setLoading(true);
            const response = await getSupAbandonList('trip', 'open', limit, offSet);

            setBookings(response?.data?.bookings ?? []);
        } catch (error) {
            console.error('Error fetching abandon bookings:', error);
            setBookings([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchOrg = async () => {
            getOrganizers(setOrgData, setLoading);
        };
        fetchOrg();
    }, []);

    useEffect(() => {
        fetchAbandonBookings();
    }, [selectedOrg, selectedType, datesType, group, offSet]);

    return (
        <div className='supAbandonBookingsContainer'>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='alignCenter'>
                <h2 className='orgBookingHeading'>Abandon Bookings</h2>
                <div className='orgBookingFilters'>
                    <select
                        name='org'
                        id='org'
                        className='select'
                        // value={selectedOrg}
                        // onChange={(e) => {
                        //     setSelectedOrg(e.target.value);
                        //     setSelectedDate('');
                        //     setSelectedTrip('');
                        //     setOffSet(0);
                        //     setPageNumber(1);
                        // }}
                    >
                        <option value=''>Select Organizer</option>
                        {orgData.map((org) => (
                            <option value={org._id} key={org._id}>
                                {org.companyName}
                            </option>
                        ))}
                    </select>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        // onChange={(e) => {
                        //     setSelectedDate('');
                        //     setSelectedTrip('');
                        //     setSelectedType(e.target.value);
                        //     setPageNumber(1);
                        //     setOffSet(0);
                        // }}
                    >
                        <option value='upcoming'>Upcoming</option>
                        <option value='completed'>Completed</option>
                    </select>
                    <select
                        name='datesType'
                        id='datesType'
                        className='select'
                        // onChange={(e) => {
                        //     setSelectedDate('');
                        //     setSelectedTrip('');
                        //     setDatesType(e.target.value);
                        //     setPageNumber(1);
                        //     setOffSet(0);
                        // }}
                    >
                        <option value='fixed'>Fixed</option>
                        <option value='custom'>Custom</option>
                    </select>
                    <select
                        name='datesType'
                        id='datesType'
                        className='select'
                        // onChange={(e) => {
                        //     setSelectedDate('');
                        //     setSelectedTrip('');
                        //     setGroup(e.target.value);
                        //     setPageNumber(1);
                        //     setOffSet(0);
                        // }}
                    >
                        <option value='backpacking'>Backpacking</option>
                        <option value='vehicle'>Vehicle</option>
                    </select>
                </div>
            </div>
            <div className='orgBookingContainer'>
                {bookings.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {bookings.length > 0 &&
                                    bookings?.map((row, rowIndex) => {
                                        return (
                                            <tr className='tableBodyRow allowCLick'>
                                                <td>{row?.tripName}</td>
                                                <td>{row?.userDetails[0].name}</td>
                                                <td>{row?.startCity}</td>
                                                <td>{row?.pickupLocation}</td>
                                                <td>{standardDate(row?.createdAt)}</td>
                                                <td
                                                    style={{
                                                        color:
                                                            row?.amountPaid?.isReserved ||
                                                            row?.amountPaid?.isInstallment
                                                                ? 'red'
                                                                : '',
                                                        textAlign: 'center',
                                                        whiteSpace: 'pre-line',
                                                        verticalAlign: 'middle'
                                                    }}
                                                >
                                                    {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                        ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                                              row?.amountPaid?.isReserved
                                                                  ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                                  : row?.amountPaid?.isInstallment
                                                                    ? `(₹${row?.amountPaid?.installments?.[0]?.amount})`
                                                                    : ''
                                                          }
                                              Total: ${row?.amountPaid?.total}
                                              Paid: ${row?.amountPaid?.paid}
                                              Balance: ${row?.amountPaid?.total - row?.amountPaid?.paid}`
                                                        : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                                </td>
                                                <td>{row?.totalSeats}</td>
                                                <td>{row?.transport}</td>
                                                <td>{row?.bookedVia}</td>
                                                <td>{getUserDetails(row)}</td>
                                                <td>{row.tripStatus}</td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SupAbandonBookings;
